import TeacherSubscribeAudit from './src/main';

/* istanbul ignore next */
TeacherSubscribeAudit.install = function(Vue) {
  Vue.component(TeacherSubscribeAudit.name, TeacherSubscribeAudit);
};

export default TeacherSubscribeAudit;
